import './Workspace.css';
import './PlatformPolish.css';
// src/components/UserLayout.js
//
// Layout da área logada do USUÁRIO comum (/dashboard/*). Mesmo shell visual do
// AdminLayout (sidebar escura + topbar + outlet), mas com o menu do usuário —
// sem nada de administração (leiloeiros, banners, importar, leads, usuários...).
// Mantido separado do AdminLayout de propósito, pra não arriscar a área admin.
import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import {
  LayoutDashboard,
  Search as SearchIcon,
  MapPin,
  Heart,
  Bell,
  BarChart3,
  FileDown,
  UserCog,
  ChevronLeft,
  ChevronRight,
  LogOut,
} from 'lucide-react';
import logoAzul from '../assets/logo-leilancer.png';
import { logout } from '../utils/session';
import Leila from './Leila';
import AvisosBuscas from './AvisosBuscas';
import ProgressoAluno from './ProgressoAluno';
import {abrirAnalyser} from '../utils/abrirAnalyser';

// Menu do usuário comum. Cada item aponta pra uma rota filha de /dashboard.
const MENU = [
  { icon: LayoutDashboard, label: 'Meu Painel',     path: '/dashboard' },
  { icon: SearchIcon,      label: 'Buscar Imóveis',  path: '/dashboard/buscar' },
  { icon: MapPin,          label: 'Mapa de Leilões', path: '/dashboard/mapa' },
  { icon: Heart,           label: 'Favoritos',       path: '/dashboard/favoritos' },
  { icon: Bell,            label: 'Meus Alertas',    path: '/dashboard/alertas' },
  { icon: SearchIcon, label: 'Minhas buscas', path: '/dashboard/minhas-buscas' },
  { icon: BarChart3,       label: 'Minhas Análises', path: '/dashboard/analises' },
  { icon: SearchIcon, label: 'Leilancer Analyser', path: '/dashboard/analyser', analyser:true },
  { icon: FileDown, label: 'Vitrine de cursos', path: '/dashboard/vitrine' },
  { icon: FileDown, label: 'Área de Membros', path: '/dashboard/membros' },
  { icon: FileDown,        label: 'Meus Materiais',  path: '/dashboard/materiais' },
  { icon: UserCog,         label: 'Minha Conta',     path: '/dashboard/conta' },
];

// Dias que ainda faltam para o fim do teste gratuito
function diasRestantesTrial(iso) {
  if (!iso) return 0;
  return Math.max(0, Math.ceil((new Date(iso) - new Date()) / 86400000));
}

// Formata o fim do trial pra "DD/MM/AAAA"
function fmtData(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('pt-BR');
  } catch { return null; }
}

export default function UserLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [user,setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('user')); } catch { return null; }
  });

  // Fecha o drawer ao trocar de rota no mobile
  React.useEffect(() => {
    if (window.matchMedia('(max-width: 767px)').matches) setSidebarOpen(false);
  }, [location.pathname]);

  const handleLogout = () => logout('/login');

  const [fotoPerfil,setFotoPerfil]=useState(null);
  useEffect(()=>{
    let ativo=true;
    const atualizar=async()=>{try{
      const r=await fetch((process.env.REACT_APP_API_URL||'')+'/api/usuarios/me/perfil',{headers:{Authorization:'Bearer '+sessionStorage.getItem('token')}});
      if(!r.ok)return;const p=await r.json();if(!ativo)return;
      setFotoPerfil(p.foto||null);setUser(u=>({...u,name:p.name,email:p.email}));
    }catch{}};
    atualizar();window.addEventListener('leilancer-profile-updated',atualizar);
    return()=>{ativo=false;window.removeEventListener('leilancer-profile-updated',atualizar);};
  },[]);
  const plano = user?.plan || 'starter';
  const trialAte = fmtData(user?.trial_ends_at);
  const trialDias = diasRestantesTrial(user?.trial_ends_at);

  return (
    <div className="lc-shell flex flex-col h-screen overflow-hidden relative">
        <header className="lc-topbar h-16 border-b flex items-center justify-between gap-3 px-4 md:px-6 flex-shrink-0 relative z-50">
          <Link to="/" aria-label="Leilancer — início" className="flex-shrink-0">
            <img src={logoAzul} alt="Leilancer" className="h-8 w-auto max-w-[100px] sm:max-w-[160px] object-contain" />
          </Link>


          <div className="flex items-center justify-end gap-2 flex-1 min-w-0">
            <Link
              to="/dashboard/buscar"
              className="lc-student-search text-sm text-white/60 hover:text-white transition inline-flex items-center gap-2"
            >
              <SearchIcon className="w-4 h-4" /> Buscar imóveis
            </Link>

          </div>
          <AvisosBuscas />
          {trialAte && (
            <Link
              to="/planos"
              className="hidden xl:inline-flex items-center gap-2 text-xs font-semibold bg-amber-400/15 text-amber-300 px-3 py-1.5 rounded-full hover:bg-amber-400/25 transition"
            >
              Teste · faltam {trialDias} {trialDias === 1 ? 'dia' : 'dias'} (até {trialAte})
            </Link>
          )}
          <ProgressoAluno foto={fotoPerfil} nome={user?.name}/>
        </header>
      <div className="relative flex flex-1 min-h-0 overflow-hidden">
          <button
            type="button"
            onClick={() => setSidebarOpen(v => !v)}
            className={`lc-sidebar-toggle absolute top-2 ${sidebarOpen ? "left-[212px]" : "left-1"} z-50 p-2 min-h-[44px] min-w-[44px] md:min-h-[32px] md:min-w-[32px] flex-shrink-0 rounded-lg opacity-80 hover:opacity-100 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary`}
            aria-label={sidebarOpen ? "Recolher menu lateral" : "Abrir menu lateral"}
            title={sidebarOpen ? "Recolher menu lateral" : "Abrir menu lateral"}
            aria-expanded={sidebarOpen}
            aria-controls="menu-lateral"
          >
            {sidebarOpen ? <ChevronLeft className="w-5 h-5" strokeWidth={3} /> : <ChevronRight className="w-5 h-5" strokeWidth={3} />}
          </button>
      {/* Backdrop mobile */}
      {sidebarOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/60 z-30"
          onClick={() => setSidebarOpen(false)}
          aria-hidden
        />
      )}

      {/* Sidebar */}
      <aside
        id="menu-lateral"
        aria-label="Menu principal"
        hidden={!sidebarOpen}
        style={!sidebarOpen ? { display: 'none' } : undefined}
        className={`
          w-64 flex-shrink-0
          lc-sidebar bg-dark text-white border-r border-white/10 transition-all duration-300 flex flex-col
          fixed md:relative top-16 bottom-0 md:top-auto md:bottom-auto left-0 z-40
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:hidden'}
        `}
      >
        {/* Menu */}
        <nav className="flex-1 overflow-y-auto pt-14 pb-4 px-2 space-y-1">
          {MENU.map((item) => {
            const Icon = item.icon;
            if(item.analyser)return <button key={item.path} type="button" title="Investigação aprofundada" aria-label="Leilancer Analyser" onClick={()=>abrirAnalyser(location,navigate)} className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition group hover:bg-white/5"><Icon className="w-5 h-5 flex-shrink-0"/>{sidebarOpen&&<span className="text-sm font-medium">Leilancer Analyser</span>}</button>;
            // "Meu Painel" (/dashboard) precisa de match exato pra não ficar
            // sempre ativo; os demais usam prefixo.
            const isActive = item.path === '/dashboard'
              ? location.pathname === '/dashboard'
              : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                aria-current={isActive ? 'page' : undefined}
                className={`flex items-center gap-3 px-3 py-3 rounded-lg transition group ${
                  isActive ? 'bg-primary text-white' : 'hover:bg-white/5'
                }`}
              >
                <Icon className="w-5 h-5 flex-shrink-0" />
                {sidebarOpen && <span className="text-sm font-medium">{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        {/* User info + trial */}
        <div className="border-t border-white/10 p-4">
          <div className={`flex items-center gap-3 ${!sidebarOpen && 'justify-center'}`}>
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-[#E2BF77] flex items-center justify-center font-bold">
              {fotoPerfil ? <img src={fotoPerfil} alt="Sua foto de perfil" className="w-full h-full rounded-full object-cover" /> : user?.name?.charAt(0)}
            </div>
            {sidebarOpen && (
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{user?.name?.split(' ')[0]}</p>
                <p className="text-xs text-white/60 truncate">{user?.email}</p>
                <span className="inline-block mt-1 px-2 py-0.5 text-[10px] font-bold rounded bg-amber-400/20 text-amber-300">
                  {trialAte ? `TESTE · ${trialDias} ${trialDias === 1 ? 'DIA' : 'DIAS'}` : `PLANO ${String(plano).toUpperCase()}`}
                </span>
              </div>
            )}
          </div>
          <button
            onClick={handleLogout}
            className="mt-3 w-full flex items-center justify-center gap-2 px-3 py-2 bg-primary hover:bg-primary-hover rounded-lg text-sm font-semibold transition"
          >
            <LogOut className="w-4 h-4" />
            {sidebarOpen && 'Sair'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Top Bar */}


        {/* Content — fundo claro (as páginas do usuário usam tema claro) */}
        <div className="lc-workspace flex-1 overflow-y-auto overflow-x-hidden bg-gray-50 text-gray-900">
          <Outlet />
        </div>
      </main>
      </div>

      {/* Assistente de busca — acompanha o usuário em todas as telas logadas */}
      <Leila />
    </div>
  );
}






